import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Store } from '../../state/store.interfaces';
import Icon from '../../common/components/Icon/Icon';
import { LrvText } from '../../common/components/LrvText/LrvText';
import { LrvModal } from '../../common/components/LrvModal/LrvModal';
import { LrvDivider } from '../../common/components/LrvDivider/LrvDivider';
import { MultifactorAuthenticationMethod } from '../Settings/TabMFA/helpers';

import styles from './VerificationMethodForm.module.scss';
import * as authSlice from './authSlice';

interface Props {
  theme?: 'light' | 'dark';
}

export const VerificationMethodForm = (props: Props) => {
  const { theme = 'light' } = props;

  const [t] = useTranslation();
  const dispatch = useDispatch();
  const {
    showVerificationMethodModal,
  } = useSelector((state: Store) => state.auth);
  
  const renderAuthenticatorAppOption = () => {
    return (
      <div
        onClick={() => {
          dispatch(authSlice.setSelectedMethod(MultifactorAuthenticationMethod.AUTHENTICATOR_APP));
          dispatch(authSlice.setShowVerificationMethodModal(false));
        }}
        className={styles.row}
      >
        <Space>
          <div className={styles.containerIcon}>
            <Icon name='smartphone' theme={theme} className={styles.icon} />
          </div>

          <div className={styles.description}>
            <LrvText text={t('mfa.app')} theme={theme}/>
          </div>
        </Space>

        <Icon name='arrow-right-s' theme={theme} className={styles.icon} />
      </div>
    );
  };

  const renderAuthenticatorEmailOption = () => {
    return (
      <div
        onClick={() => {
          dispatch(authSlice.setSelectedMethod(MultifactorAuthenticationMethod.EMAIL));
          dispatch(authSlice.setShowVerificationMethodModal(false));
        }}
        className={styles.row}
      >
        <Space>
          <div className={styles.containerIcon}>
            <Icon name='mail' theme={theme} className={styles.icon} />
          </div>

          <div className={styles.description}>
            <LrvText text={t('mfa.email')} theme={theme}/>
          </div>
        </Space>

        <Icon name='arrow-right-s' theme={theme} className={styles.icon} />
      </div>
    );
  };

  return (
    <LrvModal
      theme={theme}
      title={t('signIn.verification.title')}
      open={showVerificationMethodModal}
      destroyOnClose={true}
      className={styles.container}
      closeIcon={<Icon id='close_modal' name='close' />}
      cancelText={t('actions.cancel')}
      onCancel={() => {
        dispatch(authSlice.setShowVerificationMethodModal(false));
      }}
      onOk={undefined}
      okButtonProps={{ hidden: true }}
    >
      {renderAuthenticatorAppOption()}
      <LrvDivider theme={theme} className={styles.divider} />
      {renderAuthenticatorEmailOption()}
    </LrvModal>
  );
};
